import { type App } from '~/app';
import { isMobile } from '~/framework/helpers/browser/media-query';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Anchor Links Component');

    app.afterMount
        .then(() => {
            // Desktop
            mountAnchorLinks();
        })
        .catch((error: ErrorOptions) => {
            throw new Error('[Stockland FE] Unable to register Stockland Anchor Links Island Component', error);
        });

    return function destroyVerticalScrollCarousel() {
        app.logger.debug('[DXA] Anchor Links Component destroyed');
    };
}

function mountAnchorLinks() {
    for (const link of document.querySelectorAll(".anchor-links-link") as NodeListOf<HTMLAnchorElement>) {
        const triggerLink = () => {
            window.location.hash = '';
            window.location.assign(link.href);
        };

        link.addEventListener("click", (event: MouseEvent) => {
            // Stop the implicit navigation to #
            event.preventDefault();

            if (isMobile()) {
                // Trigger the link after a delay to ensure the dropdown closes first
                setTimeout(triggerLink, 500);
            } else {
                // There is no dropdown on mobile, so immediately trigger the link
                triggerLink();
            }
        });
    }
}
